/**
 * Removes srcset attributes from img tags in HTML content
 * @param {string} htmlContent - The HTML content string
 * @returns {string} - HTML content with srcset attributes removed
 */
export default function removeImgSrcset(htmlContent) {
    if (!htmlContent || typeof htmlContent !== 'string') {
        return htmlContent;
    }
    
    // Regular expression to match img tags with srcset attributes
    // This pattern matches: <img ... srcset="..." ...> or <img ... srcset='...' ...>
    const imgSrcsetRegex = /<img([^>]*?)\s+srcset\s*=\s*["'][^"']*["']([^>]*?)>/gi;
    
    // Replace img tags by removing the srcset attribute
    return htmlContent.replace(imgSrcsetRegex, (match, beforeSrcset, afterSrcset) => {
        // Clean up any extra spaces that might be left behind
        const cleanedBefore = beforeSrcset.replace(/\s+$/, '');
        const cleanedAfter = afterSrcset.replace(/^\s+/, '');
        
        // Reconstruct the img tag without srcset
        return `<img${cleanedBefore}${cleanedAfter}>`;
    });
}
